import React from 'react';
import { connect } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import objectAssign from 'object-assign';
import { ValidMe } from '../../../../businessLogic/validation.js';

export default function CenterPanelUpdate(props) {
  const isEmpty = (value) => {
    if (value) {
      return false;
    }
    return true;
  };

  let supportEmailAddress = props.defaultValueIsPicked
    ? 'mailto:' + props.supportContactForm.organisaionSupportEmail
    : 'mailto:' + props.supportContactForm.supportEmail;
  return (
    <div className="ui form mrbl">
      <div className="bold title-sms">{APP.LANGUAGE.SupportContactModal.SupportInfoForProviders}</div>
      <div className="mrbm mrtm">
        <div className="placeholder-label color-placeholder">{APP.LANGUAGE.SupportContactModal.SupportNameView}</div>
        <div className="title-sms">
          {props.defaultValueIsPicked
            ? props.supportContactForm.organisaionSupportName || 'Not provided'
            : props.supportContactForm.supportName || 'Not provided'}
        </div>
      </div>
      <div className="mrbm">
        <div className="placeholder-label color-placeholder">{APP.LANGUAGE.SupportContactModal.SupportEmailView}</div>
        {!!props.supportContactForm.supportEmail || !!props.supportContactForm.organisaionSupportEmail ? (
          <a
            target="support-contact"
            onClick={() => {
              window.location.href = supportEmailAddress;
            }}
          >
            {props.defaultValueIsPicked
              ? props.supportContactForm.organisaionSupportEmail
              : props.supportContactForm.supportEmail}
          </a>
        ) : (
          <div className="title-sms">Not provided</div>
        )}
      </div>
      <div className="mrbm">
        <div className="placeholder-label color-placeholder">{APP.LANGUAGE.SupportContactModal.SupportTelView}</div>
        <div className="title-sms">
          {props.defaultValueIsPicked
            ? props.supportContactForm.organisaionSupportPhone || 'Not provided'
            : props.supportContactForm.supportPhone || 'Not provided'}
        </div>
      </div>
      <div className="mrbm">
        <div className="placeholder-label color-placeholder">{APP.LANGUAGE.SupportContactModal.SupportWebsiteView}</div>
        {!!props.supportContactForm.supportWebsite ||
        (!!props.supportContactForm.organisaionSupportWebsite &&
          props.supportContactForm.organisaionSupportWebsite !== 'Not available' &&
          props.supportContactForm.organisaionSupportWebsite !== 'Not provided') ? (
          <a
            className="mrbm"
            target="support-contact"
            href={
              props.defaultValueIsPicked
                ? props.supportContactForm.organisaionSupportWebsite
                : props.supportContactForm.supportWebsite
            }
          >
            {props.defaultValueIsPicked
              ? props.supportContactForm.organisaionSupportWebsite
              : props.supportContactForm.supportWebsite}
          </a>
        ) : (
          <div className="title-sms mrbxl">Not provided</div>
        )}
      </div>
    </div>
  );
}
